<template>
    <p class="text-remaining-char">
        {{ remainingCharacters }} character(s) remaining
    </p>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: ""
        },
        maxLength: {
            type: Number,
            default: 1600
        }
    },
    computed: {
        remainingCharacters() {
            return this.maxLength - this.text.length;
        }
    },
    watch: {
        remainingCharacters(value) {
            // check if value not null
            if (value === null) {
                return;
            }
            this.$emit("remaining-characters", value);

            if (value === 0) {
                this.$emit("max-length-reached", true);
            } else {
                this.$emit("max-length-reached", false);
            }
        }
    }
};
</script>

<style scoped>
.text-remaining-char {
    color: grey;
    margin-top: 5px;
    font-size: 10px;
}
</style>
